import { createAsyncThunk } from '@reduxjs/toolkit'
import okHttp from '@helper/okHttp'
import { dict, order, getTypePrefix } from '@/api'

/**
 * 来源类型
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getSourceTypeListAction = createAsyncThunk(
    getTypePrefix(order.getSourceTypeListUrl),
    async (params) => await okHttp(order.getSourceTypeListUrl, {
        method: 'GET',
        params
    })
)

/**
 * 获取配送方式
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getDeliveryWayAction = createAsyncThunk(
    getTypePrefix(order.getDeliveryWayListUrl),
    async (params) => await okHttp(order.getDeliveryWayListUrl, {
        method: 'GET',
        params
    })
)

/**
 * 获取订单类型
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getOrderDictInfoByTypeAction = createAsyncThunk(
    getTypePrefix(`${dict.getDictListUrl}_order_type`),
    async (params) => await okHttp(dict.getDictListUrl, {
        method: 'GET',
        params: {
	        ...params,
	        type: 'order_type'
        }
    })
)

/**
 * 获取支付方式
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getPayDictInfoByTypeAction = createAsyncThunk(
    getTypePrefix(`${dict.getDictListUrl}_pay_method`),
    async (params) => await okHttp(dict.getDictListUrl, {
        method: 'GET',
	    params: {
		    ...params,
		    type: 'pay_method'
	    }
    })
)

/**
 * 获取订单列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getOrderListAction = createAsyncThunk(
    getTypePrefix(order.getOrderListUrl),
    async (params) => await okHttp(order.getOrderListUrl, {
        method: 'POST',
	    ...params
    })
)
